import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=74e84096&scoped=true&"
import script from "./blank.vue?vue&type=script&lang=ts&"
export * from "./blank.vue?vue&type=script&lang=ts&"
import style0 from "./blank.vue?vue&type=style&index=0&id=74e84096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e84096",
  null
  
)

export default component.exports